import React from 'react';
import LayoutContainer from '../../LayoutContainer';
import Image from '../../Image';
import {
  LocalBusinessInfoGraphic,
  LocalBusinessInfoGraphicWebp,
  LocalBusinessInfoCheck,
  LocalBusinessInfoHomeGraphic,
  LocalBusinessInfoHomeGraphicWebp,
} from '../../../assets/landing';
import './styles.css';

const LocalBusinessInfo = ({
  isHome,
  title = 'All the information you need for local businesses in one place.',
  subTitle = 'Search for businesses open now, with buy now pay later options, read reviews, request quotes or contact them via phone or email. Plus, all the information is up to date',
}) => {
  const INFO_LIST = [
    'Reviews',
    'Photos',
    'Quotes',
    'Quick Contact',
    'Payment Methods',
    'Get Directions',
    'Trading Hours',
    'Price Guide',
  ];

  return (
    <div className="Landing__LocalBusinessInfo__root">
      <LayoutContainer>
        <div className="Landing__LocalBusinessInfo__content">
          <div className="Landing__LocalBusinessInfo__graphic">
            <Image
              src={
                isHome
                  ? LocalBusinessInfoHomeGraphicWebp
                  : LocalBusinessInfoGraphicWebp
              }
              fallback={
                isHome ? LocalBusinessInfoHomeGraphic : LocalBusinessInfoGraphic
              }
              alt="localbusiness grahpic"
            />
          </div>
          <div>
            <div className="Landing__LocalBusinessInfo__title">{title}</div>
            <div className="Landing__LocalBusinessInfo__text">{subTitle}</div>
            <ul>
              {INFO_LIST.map(item => (
                <li key={item}>
                  <img src={LocalBusinessInfoCheck} alt="check" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </LayoutContainer>
    </div>
  );
};

export default LocalBusinessInfo;
